import { defineComponent as p, createElementBlock as o, openBlock as l, mergeProps as i, unref as e, renderSlot as u, createCommentVNode as Z, createElementVNode as n } from "vue";
import { useScalarIcon as H } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, M = { key: 1 }, g = { key: 2 }, f = { key: 3 }, A = { key: 4 }, L = { key: 5 }, k = {
  name: "ScalarIconEnvelopeSimple"
}, y = /* @__PURE__ */ p({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: V, weight: a } = H(s);
    return (d, t) => (l(), o("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(V)), [
      u(d.$slots, "default"),
      e(a) === "bold" ? (l(), o("g", m, t[0] || (t[0] = [
        n("path", { d: "M224,44H32A12,12,0,0,0,20,56V192a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V56A12,12,0,0,0,224,44ZM193.15,68,128,127.72,62.85,68ZM44,188V83.28l75.89,69.57a12,12,0,0,0,16.22,0L212,83.28V188Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (l(), o("g", M, t[1] || (t[1] = [
        n("path", {
          d: "M224,56l-96,88L32,56Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM203.43,64,128,133.15,52.57,64ZM216,192H40V74.19l82.59,75.71a8,8,0,0,0,10.82,0L216,74.19V192Z" }, null, -1)
      ]))) : e(a) === "fill" ? (l(), o("g", g, t[2] || (t[2] = [
        n("path", { d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48Zm-8,144H40V74.19l82.59,75.71a8,8,0,0,0,10.82,0L216,74.19V192Z" }, null, -1)
      ]))) : e(a) === "light" ? (l(), o("g", f, t[3] || (t[3] = [
        n("path", { d: "M224,50H32a6,6,0,0,0-6,6V192a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A6,6,0,0,0,224,50ZM208.58,62,128,135.86,47.42,62ZM216,194H40a2,2,0,0,1-2-2V69.64l86,78.78a6,6,0,0,0,8.1,0L218,69.64V192A2,2,0,0,1,216,194Z" }, null, -1)
      ]))) : e(a) === "regular" ? (l(), o("g", A, t[4] || (t[4] = [
        n("path", { d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM203.43,64,128,133.15,52.57,64ZM216,192H40V74.19l82.59,75.71a8,8,0,0,0,10.82,0L216,74.19V192Z" }, null, -1)
      ]))) : e(a) === "thin" ? (l(), o("g", L, t[5] || (t[5] = [
        n("path", { d: "M224,52H32a4,4,0,0,0-4,4V192a12,12,0,0,0,12,12H216a12,12,0,0,0,12-12V56A4,4,0,0,0,224,52Zm-10.28,8L128,138.57,42.28,60ZM216,196H40a4,4,0,0,1-4-4V65.09L125.3,147a4,4,0,0,0,5.4,0L220,65.09V192A4,4,0,0,1,216,196Z" }, null, -1)
      ]))) : Z("", !0)
    ], 16));
  }
});
export {
  y as default
};
